/**
 * English language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_EN_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'My Profile',
    'lvt.menu.tw_profile': 'TW Profile',
    'lvt.menu.company_profile': 'Company Profile',
    'lvt.menu.my_notifications': 'My Notifications',
    'lvt.menu.sign_out': 'Sign Out',

    // footer
    'lvt.footer.back_to_top': 'Back to top',
    'lvt.footer.terms_of_use': 'Terms of Use',
    'lvt.footer.privacy_policy': 'Privacy Policy',
    'lvt.footer.support_information': 'Support Information',
    'lvt.footer.transwide_home': 'Transwide Home',
    'lvt.footer.license_nr': 'License nr.:',
    'lvt.footer.build_version': 'Build version:',

    // order list columns
    'lvt.order_list.header': 'Order list',
    'lvt.order_list.column.shipperCompany': 'Shipper company',
    'lvt.order_list.column.reference': 'Reference',
    'lvt.order_list.column.status': 'Status',
    'lvt.order_list.column.statusReason': 'Status reason',
    'lvt.order_list.column.senderCompany': 'Sender company',
    'lvt.order_list.column.senderZipcode': 'Sender zipcode',
    'lvt.order_list.column.senderCity': 'Sender city',
    'lvt.order_list.column.receiverCompany': 'Receiver company',
    'lvt.order_list.column.receiverZipcode': 'Receiver zipcode',
    'lvt.order_list.column.receiverCity': 'Receiver city',
    'lvt.order_list.column.carrierName': 'Carrier name',
    'lvt.order_list.column.plannedPickupEndDate': 'Planned pickup',
    'lvt.order_list.column.etaPickup': 'ETA pickup',
    'lvt.order_list.column.delayAtPickup': 'Delay at pickup',
    'lvt.order_list.column.plannedDeliveryEndDate': 'Planned delivery',
    'lvt.order_list.column.etaDelivery': 'ETA delivery',
    'lvt.order_list.column.delayAtDelivery': 'Delay at delivery',
    'lvt.order_list.column.timestamps': 'Timestamps',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': 'Requested',
    'lvt.order_list.status.failed': 'Error',
    'lvt.order_list.status.waiting': 'Waiting',
    'lvt.order_list.status.active': 'Active',
    'lvt.order_list.status.stopped': 'Error',
    'lvt.order_list.status.completed': 'Completed',
    'lvt.order_list.status.cancelled': 'Cancelled',
    'lvt.order_list.status.timeout': 'Stopped',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': 'Carrier not assigned',
    'lvt.order_list.status_reason.plate_number_not_present': 'Plate number not present',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'Plate number not recognized',
    'lvt.order_list.status_reason.plate_number_not_operational': 'Plate number not operational',
    'lvt.order_list.status_reason.technical_error_not_posted': 'Technical error when creating the tour in GH',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'rows per page',
    'lvt.order_list.pagination.first': 'First',
    'lvt.order_list.pagination.previous': 'Previous',
    'lvt.order_list.pagination.next': 'Next',
    'lvt.order_list.pagination.last': 'Last',
    'lvt.order_list.pagination.no_orders_found': 'No orders found',

    // tracked device
    'lvt.map.tracked_device.trailer': 'Trailer',
    'lvt.map.tracked_device.tractor': 'Tractor',
    'lvt.map.tracked_device.mobile': 'Mobile',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'Open order list',
    'lvt.map.traffic_information.traffic': 'Traffic',
    'lvt.map.traffic_information.fast': 'Fast',
    'lvt.map.traffic_information.slow': 'Slow',
    'lvt.map.pickup_popup.pickup': 'Pickup',
    'lvt.map.pickup_popup.date': 'Date',
    'lvt.map.pickup_popup.address': 'Address',
    'lvt.map.delivery_popup.delivery': 'Delivery',
    'lvt.map.delivery_popup.date': 'Date',
    'lvt.map.delivery_popup.address': 'Address',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': 'In transit to at delivery',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'In transit to at pickup',
    'lvt.map.current_gps_popup.current_speed': 'Current speed',
    'lvt.map.current_gps_popup.average_speed': 'Average speed',
    'lvt.map.current_gps_popup.last_location_update': 'Last location update',
    'lvt.map.current_gps_popup.eta': 'ETA',
    'lvt.map.current_gps_popup.planned_time': 'Planned time',
    'lvt.map.current_gps_popup.arrival_delay': 'Arrival delay',
    'lvt.map.current_gps_popup.speed_unit': 'km/h',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'Arrived at origin',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'Not arrived at origin',
    'lvt.order_list.timestamp.left_origin': 'Left origin',
    'lvt.order_list.timestamp.not_left_origin': 'Not left origin',
    'lvt.order_list.timestamp.arrived_at_destination': 'Arrived at destination',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'Not arrived at destination',
    'lvt.order_list.timestamp.left_destination': 'Left destination',
    'lvt.order_list.timestamp.not_left_destination': 'Not left destination',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search',

    'loginform.header': 'twSlot login',
    'loginform.username': 'Username',
    'loginform.password': 'Password',
    'loginform.username_required': 'Username is required!',
    'loginform.password_required': 'Password is required!',
    'loginform.login': 'Login'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-en.ts